var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"max-width":"96%"},attrs:{"fluid":""}},[_c('div',{staticClass:"provider"},[_c('BaseTitle',{attrs:{"pageTitle":_vm.pageTitle}}),_c('v-row',[_c('v-col',[_c('Form',{attrs:{"pageTitle":_vm.pageTitle}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }